import VectorIcon from './VectorIcon';

type GridIconProps = {
  stroke?: string;
  width?: number;
  height?: number;
};

const GridIcon = ({
  width = 24,
  height = 24,
  stroke = 'white',
}: GridIconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M10 3H3V10H10V3Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 3H14V10H21V3Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 14H14V21H21V14Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14H3V21H10V14Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </VectorIcon>
);

export default GridIcon;
